var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g;
import { RArray } from "../collections";
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { LocalizationProvider } from "../locale";
import { FulfillmentTimeScope, ProductInstancePartAvailabilityService, ModifierInstanceAvailabilityService, ModifierInstancePriceService, } from "../ordering";
import { PModifierInstanceCreator } from "./PModifierInstanceCreator";
import { PModifierSectionCreatorFactory } from "./PModifierSectionCreatorFactory";
import { PProductInstanceCreatorPart } from "./PProductInstanceCreatorPart";
import { PRestaurant } from "./PRestaurant";
let PProductInstanceCreatorPartFactory = class PProductInstanceCreatorPartFactory {
    constructor(productInstancePartAvailabilityService, modifierInstanceAvailabilityService, modifierInstancePriceService, pModifierSectionCreatorFactory, localizationProvider, restaurant, fulfillmentTimeScope) {
        this.productInstancePartAvailabilityService = productInstancePartAvailabilityService;
        this.modifierInstanceAvailabilityService = modifierInstanceAvailabilityService;
        this.modifierInstancePriceService = modifierInstancePriceService;
        this.pModifierSectionCreatorFactory = pModifierSectionCreatorFactory;
        this.localizationProvider = localizationProvider;
        this.restaurant = restaurant;
        this.fulfillmentTimeScope = fulfillmentTimeScope;
        makeImmutable(this);
    }
    create(params) {
        const productType = this.restaurant.productTypes.get(params.productTypeId);
        const modifierInstanceCreators = new RArray(params.domain.modifierInstanceCreators.objects
            .map((modifierInstanceCreator) => new PModifierInstanceCreator({
            domain: modifierInstanceCreator,
            modifierInstanceAvailabilityService: this.modifierInstanceAvailabilityService,
            modifierInstancePriceService: this.modifierInstancePriceService,
            modifierType: this.restaurant.modifierTypes.get(modifierInstanceCreator.typeId),
            localizationProvider: this.localizationProvider,
            pModifierSectionCreatorFactory: this.pModifierSectionCreatorFactory,
            creatorScopeProvider: params.creatorScopeProvider,
            packagingFeeTypes: this.restaurant.packagingFeeTypes,
        }))
            .sorted((a, b) => productType.divisibleModifiersOrder.findIndex((idx) => idx.eq(a.typeId)) -
            productType.divisibleModifiersOrder.findIndex((idx) => idx.eq(b.typeId))).raw).raw;
        return new PProductInstanceCreatorPart({
            domain: params.domain,
            productInstancePartAvailabilityService: this.productInstancePartAvailabilityService,
            productType,
            modifierInstanceCreators,
            possibleProductTypes: params.possibleProductTypes,
            restaurant: this.restaurant,
            creatorScopeProvider: params.creatorScopeProvider,
            fulfillmentTimeScope: this.fulfillmentTimeScope,
        });
    }
};
PProductInstanceCreatorPartFactory = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductInstancePartAvailabilityService !== "undefined" && ProductInstancePartAvailabilityService) === "function" ? _a : Object, typeof (_b = typeof ModifierInstanceAvailabilityService !== "undefined" && ModifierInstanceAvailabilityService) === "function" ? _b : Object, typeof (_c = typeof ModifierInstancePriceService !== "undefined" && ModifierInstancePriceService) === "function" ? _c : Object, typeof (_d = typeof PModifierSectionCreatorFactory !== "undefined" && PModifierSectionCreatorFactory) === "function" ? _d : Object, typeof (_e = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _e : Object, typeof (_f = typeof PRestaurant !== "undefined" && PRestaurant) === "function" ? _f : Object, typeof (_g = typeof FulfillmentTimeScope !== "undefined" && FulfillmentTimeScope) === "function" ? _g : Object])
], PProductInstanceCreatorPartFactory);
export { PProductInstanceCreatorPartFactory };
